import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, of } from 'rxjs';

import { MeetingManagementService } from '../pages/meeting-management/services/meeting-management.service';
import { MeetingService } from '../pages/meeting-ui/service/meeting.service';

export const meetingRoomGuard: CanActivateFn = (route, state) => {
  const meetingId = route.paramMap.get('roomID') ?? '';
  const meetingManagementService = inject(MeetingManagementService);
  const meetingService = inject(MeetingService);
  const router = inject(Router);
  const toastr = inject(ToastrService);

  // Xác định route nào đang được vào
  const currentPath = route.routeConfig?.path;
  // meeting/:roomID  hoặc  meeting-room/:roomID

  const isMeetingRoute = currentPath?.startsWith('meeting/');

  const acceptedMeetingId = meetingService.acceptedMeeting();

  return meetingManagementService.getMeetingInfo(meetingId).pipe(
    map((res) => {
      if (!res.success) {
        toastr.error(res.message);
        return false;
      }
      // Tách logic xử lý theo route
      if (isMeetingRoute) {
        meetingService.clearAcceptedMeeting();
        // check state join route with state
        const navigation = router.getCurrentNavigation();
        const previousNavigation = navigation?.previousNavigation;
        const navState = navigation?.extras?.state as { joinRoom?: string };

        const shouldRedirectToPreview =
          acceptedMeetingId !== meetingId || (!!navState && !previousNavigation);

        if (shouldRedirectToPreview) {
          meetingManagementService.setPrefetchedMeetingInfo(meetingId, res);
          return router.createUrlTree(['/meeting-room', meetingId]);
        }
      }

      return true;
    }),
    catchError((error) => {
      const err: any = JSON.parse(error);
      if (err.code === 'AVT3013') {
        toastr.error('Phòng không tồn tại!');
      } else if (err.message) {
        toastr.error(err.message);
      }

      // redirect fallback
      return of(router.createUrlTree(['/meeting-room']));
    }),
  );
};
